import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const PurchasesPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/movements/purchases/purchasesReleases`);
    }
  }, [match]);

  return null;
};

export default PurchasesPage;
